import { render, staticRenderFns } from "./agingStockStats.vue?vue&type=template&id=00282da6&scoped=true&"
import script from "./agingStockStats.vue?vue&type=script&lang=js&"
export * from "./agingStockStats.vue?vue&type=script&lang=js&"
import style0 from "./agingStockStats.vue?vue&type=style&index=0&id=00282da6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00282da6",
  null
  
)

export default component.exports